import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AuthPage.css';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem('isLoggedIn', 'true');
    // Navigate back to services section of homepage
    navigate('/#services');
    window.location.reload(); // Refresh to update pricing display
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>{isLogin ? 'Login' : 'Create Account'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input type="email" placeholder="Email" className="form-input" required />
          </div>
          <div className="form-group">
            <input type="password" placeholder="Password" className="form-input" required />
          </div>
          <button type="submit" className="cta-button">
            {isLogin ? 'Login' : 'Sign Up'}
          </button>
        </form>
        <div className="auth-switch">
          <button onClick={() => setIsLogin(!isLogin)} className="switch-btn">
            {isLogin ? 'Need an account? Sign up' : 'Already have an account? Login'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
